import { StyleDictionary } from "pdfmake/interfaces"

export const styles: StyleDictionary = {
  header: {
    alignment: "left",
    columnGap: 40,
    color: "blue",
    background: "orange",
  },
  headerItem: {
    fontSize: 12,
    color: "black",
    // @ts-ignore
    width: "100%",
  },
  eventTable: {
    // @ts-ignore
    width: "100%",
    margin: [0, 0, 0, 12],
  },
  tableTitle: {
    fillColor: "#e9e9e9",
    margin: [0, 0, 0, 0],
  },
  purchaseDate: {
    alignment: "right",
  },
  itemNameAndBatch: {
    fontSize: 14,
    bold: true,
    color: "black",
  },
  qrcode: {
    alignment: "center",
    // @ts-ignore
    width: "200px",
  },
  qrcodetext: {
    alignment: "center",
    bold: true,
    margin: [0, 10, 0, 10],
  },
  infoQuestion: {
    fontSize: 13,
    color: "#232323",
  },
  infoAnswer: {
    fontSize: 11,
    color: "#b3b3b3",
  },
  paymentsLines: {
    fontSize: 11,
    margin: [0, 0, 0, -4],
  },
  dateFooter: {
    italics: true,
    alignment: "right",
    color: "#CCC",
  },
  companyFooterTag: {
    color: "#000",
    bold: true,
  },
  companyFooter: {
    color: "#000",
  },
  contentTableHeader: {
    color: "#000",
    bold: true,
    fontSize: 11,
  },
  right: {
    alignment: "right",
  },
  debitValue: {
    color: "#B22222",
  },
  additionalInfo: {
    color: "#7A7A7A",
  },
  additionalInfoMain: {
    color: "#000",
  },
  taxValue: {
    color: "orange",
  },
  additionalInfoDesc: {
    color: "#838383",
  },
  contractTitle: {
    alignment: "center",
  },
  contractText: {
    color: "#000",
  },
  contractFooter: {
    italics: true,
    alignment: "center",
  },
}
